// web/src/components/ui/SmartImg.jsx
// An <img> that requests a display-sized variant via Cloudflare Image
// Transformations, and quietly falls back to the original if that fails.
//
// The fallback matters: /cdn-cgi/image/ 404s when transformations aren't
// enabled for the zone, and a broken avatar on every horse is a far worse
// outcome than an oversized one. This way the worst case is what we have today.

import { useState } from 'react';
import { imgUrl } from '../../lib/img';

/**
 * @param {string} src    original image URL
 * @param {number} width  intended CSS width in px (retina handled internally)
 * @param {string} fit    cover | contain | scale-down
 */
export default function SmartImg({ src, width, fit = 'cover', alt = '', ...props }) {
  const [failed, setFailed] = useState(false);
  const finalSrc = failed ? src : imgUrl(src, width, { fit });

  return (
    <img
      {...props}
      src={finalSrc}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => { if (!failed) setFailed(true); }}
    />
  );
}
